import classNames from "classnames"
import { useDispatch, useSelector } from "react-redux"
import s from './RoleList.module.css'
import { getRolesSD } from "@/selectors"
import { useOutside } from "@/hooks"
import { useEffect, useState } from "react"
import { getRolesAction } from "@store/staticData"
import { actionSetProfile, actionUpdProfile } from "@store/profile.reducer"
import { usersAPI } from "@api";
import {AuthService} from "@/services/AuthService";
import { useAddAlert } from "@hooks/useAddAlert"
import {fetchMenu} from "@store/menu.reducer";
import { selectProfile } from "../../../../../store/profile.reducer"

const RoleList = ({ userRole, roles }) => {
  const profile = useSelector(selectProfile)
  const dispatch = useDispatch()
  const roleList = useSelector(getRolesSD)
  // eslint-disable-next-line react-hooks/exhaustive-deps
  useEffect(() => { if (roleList.length < 1) dispatch(getRolesAction()) }, [])
  const [ref, isShow, setIsShow] = useOutside(false)
  const addAlert = useAddAlert()
  const setRole = role => {
    usersAPI
        .switchRole(role)
        .then(result => {
          if (result?.status === 200) {
            const user  = result.data?.user
            const token = result.data?.token

            if (user) {
              user.roles = result.data?.roles || []
              AuthService.auth(user, token)

              dispatch(actionSetProfile(user));
              dispatch(actionUpdProfile({ role }))
              dispatch(fetchMenu())
            }
          }

          if (result?.status >= 400) {
            addAlert({ text: result.data?.error, type: 'error' })
          }
        })
        .catch(error => {
          addAlert({ text: 'Попробуйте ещё раз или обратитесь к администратору', type: 'error' })
        })
        .finally(() => setIsShow(false))
  }

  const { data: rolesOrder, status: rolesStatus } = useSelector(state => state.allRoles);

  const calcOrder = (name) => {
    let order = 0;
    rolesOrder.forEach(element => {
      if(element.role==name){
        order = element?.order;
      }
    });
    return order;
  }
  if(profile?.roles?.length < 2) return (
    <></>
  )  
  return <div ref={ref} className={s.selectWrapper}>
    <button className={s.buttonNewDesin} title='Выбор роли' onClick={() => setIsShow(!isShow)}>
      <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
        <path d="M7 13C7.79113 13 8.56448 12.7654 9.22228 12.3259C9.88008 11.8864 10.3928 11.2616 10.6955 10.5307C10.9983 9.79983 11.0775 8.99556 10.9231 8.21964C10.7688 7.44372 10.3878 6.73098 9.82843 6.17157C9.26902 5.61216 8.55629 5.2312 7.78036 5.07686C7.00444 4.92252 6.20017 5.00173 5.46927 5.30448C4.73836 5.60723 4.11365 6.11992 3.67412 6.77772C3.2346 7.43552 3 8.20888 3 9C3 10.0609 3.42143 11.0783 4.17157 11.8284C4.92172 12.5786 5.93913 13 7 13ZM7 7C7.39556 7 7.78224 7.1173 8.11114 7.33706C8.44004 7.55683 8.69638 7.86918 8.84776 8.23464C8.99913 8.60009 9.03874 9.00222 8.96157 9.39018C8.8844 9.77814 8.69392 10.1345 8.41421 10.4142C8.13451 10.6939 7.77814 10.8844 7.39018 10.9616C7.00222 11.0387 6.60009 10.9991 6.23463 10.8478C5.86918 10.6964 5.55682 10.44 5.33706 10.1111C5.1173 9.78224 5 9.39556 5 9C5 8.46957 5.21071 7.96086 5.58579 7.58579C5.96086 7.21072 6.46957 7 7 7ZM12 17V19C12 19.2652 11.8946 19.5196 11.7071 19.7071C11.5196 19.8946 11.2652 20 11 20C10.7348 20 10.4804 19.8946 10.2929 19.7071C10.1054 19.5196 10 19.2652 10 19V17C10 16.7348 9.89464 16.4804 9.70711 16.2929C9.51957 16.1054 9.26522 16 9 16H5C4.73478 16 4.48043 16.1054 4.29289 16.2929C4.10536 16.4804 4 16.7348 4 17V19C4 19.2652 3.89464 19.5196 3.70711 19.7071C3.51957 19.8946 3.26522 20 3 20C2.73478 20 2.48043 19.8946 2.29289 19.7071C2.10536 19.5196 2 19.2652 2 19V17C2 16.2044 2.31607 15.4413 2.87868 14.8787C3.44129 14.3161 4.20435 14 5 14H9C9.79565 14 10.5587 14.3161 11.1213 14.8787C11.6839 15.4413 12 16.2044 12 17ZM17 11C17.7911 11 18.5645 10.7654 19.2223 10.3259C19.8801 9.88635 20.3928 9.26164 20.6955 8.53074C20.9983 7.79983 21.0775 6.99556 20.9231 6.21964C20.7688 5.44372 20.3878 4.73098 19.8284 4.17157C19.269 3.61216 18.5563 3.2312 17.7804 3.07686C17.0044 2.92252 16.2002 3.00173 15.4693 3.30448C14.7384 3.60723 14.1136 4.11992 13.6741 4.77772C13.2346 5.43552 13 6.20888 13 7C13 8.06087 13.4214 9.07828 14.1716 9.82843C14.9217 10.5786 15.9391 11 17 11ZM17 5C17.3956 5 17.7822 5.1173 18.1111 5.33706C18.44 5.55683 18.6964 5.86918 18.8478 6.23463C18.9991 6.60009 19.0387 7.00222 18.9616 7.39018C18.8844 7.77814 18.6939 8.13451 18.4142 8.41422C18.1345 8.69392 17.7781 8.8844 17.3902 8.96157C17.0022 9.03874 16.6001 8.99914 16.2346 8.84776C15.8692 8.69639 15.5568 8.44004 15.3371 8.11114C15.1173 7.78224 15 7.39556 15 7C15 6.46957 15.2107 5.96086 15.5858 5.58579C15.9609 5.21072 16.4696 5 17 5ZM22 15V17C22 17.2652 21.8946 17.5196 21.7071 17.7071C21.5196 17.8946 21.2652 18 21 18C20.7348 18 20.4804 17.8946 20.2929 17.7071C20.1054 17.5196 20 17.2652 20 17V15C20 14.7348 19.8946 14.4804 19.7071 14.2929C19.5196 14.1054 19.2652 14 19 14H15C14.8282 14.0005 14.6595 14.0453 14.51 14.13C14.3395 14.2247 14.2005 14.3673 14.11 14.54C14.0508 14.6594 13.9683 14.7658 13.8674 14.8529C13.7665 14.94 13.6491 15.006 13.5223 15.0471C13.3955 15.0882 13.2618 15.1035 13.129 15.0921C12.9962 15.0808 12.867 15.043 12.749 14.981C12.631 14.919 12.5266 14.834 12.4419 14.7311C12.3572 14.6282 12.2939 14.5093 12.2558 14.3816C12.2177 14.2539 12.2055 14.1198 12.22 13.9873C12.2344 13.8548 12.2753 13.7265 12.34 13.61C12.6116 13.0952 13.0244 12.6685 13.53 12.38C13.9793 12.1294 14.4855 11.9985 15 12H19C19.7956 12 20.5587 12.3161 21.1213 12.8787C21.6839 13.4413 22 14.2044 22 15Z" fill="black" />
      </svg>
    </button>

    <ul className={classNames(s.list, { [s.active]: isShow })}>
      {roles?.map(el => <li style={{order: calcOrder(el)}} key={el} className={classNames(s.item, { [s.active]: el === userRole })} onClick={() => { if (el !== userRole) setRole(el) }}>{el.name ?? roleList?.find(i => i.value === el)?.label}</li>)}
    </ul>
  </div >
}
export default RoleList
